/* THIS FILE IS AUTO-GENERATED – DO NOT EDIT */

import {forwardRef} from 'react'

/**
 * @public
 */
export const GroqIcon = forwardRef(function GroqIcon(
  props: React.SVGProps<SVGSVGElement>,
  ref: React.Ref<SVGSVGElement>,
) {
  return (
    <svg
      data-sanity-icon="groq"
      width="1em"
      height="1em"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      {...props}
    >
      <path d="M13 13H21L13 21L13 13Z" fill="currentColor" />
      <path d="M12 12V4L4 12H12Z" fill="currentColor" />
      <path d="M12 13H4L12 21V13Z" fill="currentColor" />
    </svg>
  )
})
GroqIcon.displayName = 'ForwardRef(GroqIcon)'
